module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "board-prospect-steps"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "board-prospect-steps__loader"
  }, [_c('span', {
    staticClass: "board-prospect-steps__spinner"
  })]) : _c('div', {
    staticClass: "dashboard-kanban"
  }, _vm._l((_vm.colProspect), function(column) {
    return _c('div', {
      key: column.id,
      staticClass: "dashboard-kanban__column"
    }, [_c('header', {
      staticClass: "dashboard-kanban__header"
    }, [_c('img', {
      staticClass: "dashboard-card__icon dashboard-card__icon--small",
      attrs: {
        "src": column.icon,
        "alt": column.name
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "dashboard-kanban__header-info"
    }, [_c('h3', {
      staticClass: "dashboard-kanban__title"
    }, [_vm._v(_vm._s(column.name))]), _vm._v(" "), _c('p', {
      staticClass: "dashboard-kanban__tagline"
    }, [_vm._v(_vm._s(column.tagline))])]), _vm._v(" "), _c('span', {
      staticClass: "dashboard-kanban__count"
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.prospectsByColumn[column.id].length) + "\n\t\t\t\t")])]), _vm._v(" "), _c('div', {
      staticClass: "dashboard-kanban__content"
    }, _vm._l((_vm.prospectsByColumn[column.id]), function(prospect) {
      return _c('CardProspect', {
        key: prospect.id,
        attrs: {
          "user": prospect
        },
        on: {
          "toggle-inscrit-partenaire": _vm.onToggleInscritPartenaire
        }
      })
    }), 1)])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5487ce6a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Board/BoardProspectSteps.vue
// module id = 1134
// module chunks = 0